import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=47edc0f8&scoped=true&"
import script from "./BookingTable.vue?vue&type=script&lang=ts&"
export * from "./BookingTable.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTable.vue?vue&type=style&index=0&id=47edc0f8&lang=scss&scoped=true&"
import style1 from "./BookingTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47edc0f8",
  null
  
)

export default component.exports